import { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { StrapiImageItem } from "_types/AssetsImage"

interface StrapiItemSettings {
  footer_logo: StrapiImageItem
  header_logo: StrapiImageItem
  hero_banner_logo: StrapiImageItem
  side_nav_logo: StrapiImageItem
  site_icon: StrapiImageItem
}

interface LogoData {
  nodes: StrapiItemSettings[]
}

interface Logos {
  faviconLogo: StrapiImageItem
  footerLogo: StrapiImageItem
  headerLogo: StrapiImageItem
  heroBannerLogo: StrapiImageItem
  sideNavLogo: StrapiImageItem
}

export const useLogos = (): Logos => {
  const data = useStaticQuery<{ allStrapiLogo: LogoData }>(getData)

  const { allStrapiLogo } = data

  const {
    footer_logo,
    header_logo,
    hero_banner_logo,
    side_nav_logo,
    site_icon,
  } = allStrapiLogo?.nodes[0]

  const faviconLogo = useMemo(() => site_icon, [site_icon])
  const footerLogo = useMemo(() => footer_logo, [footer_logo])
  const headerLogo = useMemo(() => header_logo, [header_logo])
  const heroBannerLogo = useMemo(() => hero_banner_logo, [hero_banner_logo])
  const sideNavLogo = useMemo(() => side_nav_logo, [side_nav_logo])

  return {
    faviconLogo,
    footerLogo,
    headerLogo,
    heroBannerLogo,
    sideNavLogo,
  }
}

const getData = graphql`
  query getLogoSettingsData {
    allStrapiLogo {
      nodes {
        footer_logo {
          ...StrapiBaseImageFragment
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                avifOptions: { lossless: true, speed: 10, quality: 50 }
                webpOptions: { quality: 80 }
                formats: [AUTO, AVIF, WEBP, JPG]
                layout: CONSTRAINED
                placeholder: NONE
                width: 200
              )
            }
          }
        }
        header_logo {
          ...StrapiBaseImageFragment
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                avifOptions: { lossless: true, speed: 10, quality: 50 }
                webpOptions: { quality: 80 }
                formats: [AUTO, AVIF, WEBP, JPG]
                layout: CONSTRAINED
                placeholder: NONE
                width: 200
              )
            }
          }
        }
        hero_banner_logo {
          ...StrapiBaseImageFragment
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                avifOptions: { lossless: true, speed: 10, quality: 50 }
                webpOptions: { quality: 80 }
                sizes: "200"
                formats: [AUTO, AVIF, WEBP, JPG]
                layout: CONSTRAINED
                width: 200
              )
            }
          }
        }
        sidenav_logo {
          ...StrapiBaseImageFragment
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                avifOptions: { lossless: true, speed: 10, quality: 50 }
                webpOptions: { quality: 60 }
                sizes: "200"
                formats: [AUTO, AVIF, WEBP, JPG]
                layout: CONSTRAINED
                width: 200
              )
            }
          }
        }
        site_icon {
          ...StrapiBaseImageFragment
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                avifOptions: { lossless: true, speed: 10, quality: 50 }
                webpOptions: { quality: 60 }
                sizes: "200"
                formats: [AUTO, AVIF, WEBP, JPG]
                layout: CONSTRAINED
                width: 150
              )
            }
          }
        }
      }
    }
  }
`
